import httpClient from '../httpClient';

export const getOrderCost = async (idCustomer, orderInfo) => {
  const result = await httpClient.get('/util/get-order-cost', {
    params: {
      idCustomer: idCustomer,
      orderInfo: orderInfo,
    },
  });
  return result.data;
};

export const validateCoupon = async (couponCd) => {
  const result = await httpClient.get('/util/validate-coupon', {
    params: { couponCd },
  });
  return result.data;
};

export const uploadFiles = async (formData) => {
  const result = await httpClient.post('/util/upload-files', formData);
  return result.data;
};
